module.exports = __webpack_public_path__ + "img/article-icon-102.2f20e539.svg";